<mat-card class="cardWithShadow" [style.background-color]="backgroundColor"
          [matBadge]="badge > 0 ? badge : null"
          [matBadgePosition]="'before'"
          [matBadgeOverlap]="true">
    <mat-card-header>
        <ng-container [ngTemplateOutlet]="headerContent"></ng-container>
    </mat-card-header>
    <mat-card-content>
        <ng-container *ngIf="!expandable || (expandable && expanded)"
                      [ngTemplateOutlet]="contentContent"></ng-container>
    </mat-card-content>
</mat-card>
<ng-template #headerContent>
    <div class="d-flex w-100 align-items-center" *ngIf="title || hasRawTitle || expandable">
        <div class="flex-grow-0 flex-shrink-0" *ngIf="expandable">
            <app-button (click)="onExpanded()" *ngIf="expanded" [withMargin]="false" size="small"
                        [withPadding]="false" class="ion-no-margin ion-margin-end" iconName="chevron-down"></app-button>
            <app-button (click)="onExpanded()" *ngIf="!expanded" [withMargin]="false" size="small"
                        [withPadding]="false" class="ion-no-margin ion-margin-end" iconName="chevron-right"></app-button>
        </div>
        <div class="flex-grow-1">
            <span>{{title}}</span>
            <ng-content select="[title]"></ng-content>
        </div>

        <div *ngIf="itemCount && showTotalItems === true"
             style="font-size: 0.7em; margin-right: 8px;">({{ itemCount }})
        </div>
        <ng-content select="[buttons]"></ng-content>
        <app-button (click)="refresh()" *ngIf="paginatedService && !hideRefreshButton" [withMargin]="false"
                    [withPadding]="false"
                    iconName="refresh" size="small"></app-button>
        <app-button (click)="this._onClickIcon.emit()" *ngIf="iconName" [iconName]="iconName"
                    [withMargin]="false" [withPadding]="false" size="small"></app-button>
    </div>
</ng-template>

<ng-template #contentContent>
    <div class="card__filter">
        <ng-content select="[filter]"></ng-content>
    </div>
    <app-loading [showText]="false" [loading]="loading"></app-loading>
    <div *ngIf="!loading">
        <ng-content></ng-content>
    </div>
</ng-template>
